<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Gerenciar espelhos de ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Ano</label>
              <select class="form-control" v-model="search.year">
                <option :value="year" v-for="year in years" :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Mês</label>
              <select class="form-control" v-model="search.month">
                <option :value="month" v-for="month in months" :key="month">
                  {{ monthNames[month] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2 mt-4">
            <div class="form-group">
              <label for="">Desligados?
                <input type="checkbox" name="fired" v-model="search.fired">
              </label>
            </div>
          </div>
           <div class="col-md-2 mt-4">
            <div class="form-group">
              <label for="">Fechados?
                <input type="checkbox" name="fired" v-model="search.closed">
              </label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Ação</label>
              <button class="btn btn-block btn-info" @click="getEntity">
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-striped table-bordered">
              <thead>
                <th scope="col">Nome Colaborador</th>
                <th scope="col">Departamento</th>
                <th scope="col">Cargo</th>
                <th scope="col">Últ. Mês Fechado</th>
                <th scope="col">Período</th>
                <th scope="col">Status</th>
                <th scope="col" v-if="hasSignature">Status Assinatura</th>
                <th scope="col">Ação</th>
              </thead>
              <tbody>
                <tr v-for="user in usersList" :key="user.id">
                  <td>{{ user.name }}</td>
                  <td>{{ user.department.title }}</td>
                  <td>{{ user.role.title }}</td>
                  <td>{{ user.lastClosedMonth }}</td>
                  <td>
                    {{ user.period }}
                  </td>
                  <td style="font-size: 16px; text-align: center">
                    <span v-if="!user.closed" class="badge badge-danger"
                      >Aberto</span
                    ><span v-else class="badge badge-success">Fechado</span>
                  </td>
                  <td style="font-size: 16px; text-align: center" v-if="hasSignature">
                    <span
                      v-if="!user.signature_status"
                      class="badge badge-danger"
                      >Não Assinado</span
                    ><span v-else class="badge badge-success">Assinado</span>
                
                    <span
                      v-if="user.signature_status"
                      style="font-size: 14px; text-align: center"
                    >
                      <a :href="user.signature_url" target="_blank">
                        <i class="fas fa-eye"></i> Visualizar Assinatura
                      </a>
                    </span>
                  </td>
                  <td >
                    <button
                      class="btn btn-new view"
                      @click="close(user)"
                      v-if="!user.closed"
                    >
                      <i class="fas fa-check"></i> Fechar
                    </button>
                    <button
                      class="btn btn-new view"
                      @click="close(user)"
                      v-if="user.closed"
                    >
                      <i class="fas fa-eye"></i> Visualizar
                    </button>
                    
                    <a
                      :href="downloadMirror(user.mirror_id)"
                      v-if="user.closed"
                      target="_blank"
                      class="btn btn-new edit"
                      ><i class="fas fa-download"></i> Download</a
                    >
                    
                    <button
                      @click="reopen(user.mirror_id)"
                      v-if="user.closed"
                      target="_blank"
                      class="btn btn-new delete"
                    >
                      <i class="fas fa-trash"></i> Reabrir
                    </button>
                  </td>
                </tr>

                <tr>
                  <td v-if="users.length == 0" colspan="6" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      search: {
        year: parseInt(moment().year(), 10),
        month: parseInt(moment().month(), 10),
        fired: false,
        closed: false
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    usersList(){

      return this.search.closed ? this.users : this.users.filter(function(user){ return user.closed == false})
    },
    hasSignature(){
      return this.$store.getters.has_signature;
    },
    years: function () {
      let lastYear = parseInt(moment().year(), 10);
      let availableYears = [];
      let firstYear = 2019;

      for (lastYear; lastYear >= firstYear; lastYear--) {
        availableYears.push(lastYear);
      }

      return availableYears;
    },
    months: function () {
      const self = this;
      let thisYear = parseInt(moment().year(), 10);
      let availableMonths = [];
      let lastMonth;

      if (self.search.year === thisYear) {
        lastMonth = parseInt(moment().month(), 10);
      } else {
        lastMonth = 11;
      }
      for (let i = 0; i <= lastMonth; i++) {
        availableMonths.push(i);
      }

      return availableMonths;
    },
  },
  methods: {
    downloadMirror: function (id) {
      return (
        this.$store.state.url +
        "/export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    close(data) {
      const self = this;

      let obj = {
        year: self.search.year,
        month: self.search.month,
        user_id: data.id,
        closed: data.closed,
        mirror_id: data.mirror_id,
      };
      self.$store.commit("close_mirror", obj);
      self.$router.push("/point-mirror/view");
    },
    getEntity: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "point-mirror/manager";

      self.$http
        .post(api, self.search)
        .then((response) => {
          self.users = response.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    reopen: function (id) {
      let self = this;
      let api = self.$store.state.api + "point-mirror/reopen";

      self.$http
        .post(api, { id: id })
        .then((response) => {
          self.users = response.data;
          self.$message(null, "Espelho de ponto reaberto", "success");
          self.getEntity();
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    var closeMirror   = this.$store.getters.getCloseMirror

    if(closeMirror){
      self.search.year  = closeMirror.year
      self.search.month = closeMirror.month - 1
    }

    self.getEntity();
    if (self.$route.params.month && self.$route.params.year) {
      console.log("a");
      self.search.year = self.$route.params.year;
      self.search.month = Number(self.$route.params.month) - Number(1);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PointMirror/Manager.vue